export default "__VITE_ASSET__02c59eb5__"